import {
  DashboardReportedEmissionsCalculationResult,
  DashboardV4ReportedEmissionsCalculationResult,
} from './dashboard-v4-calculation-result';

export function isDashboardV4ReportedCalculationResult(
  result: DashboardV4ReportedEmissionsCalculationResult | DashboardReportedEmissionsCalculationResult
): result is DashboardV4ReportedEmissionsCalculationResult {
  if (!result) {
    return false;
  }
  if (!result.inventoryEmissions) {
    return false;
  }
  const dict = result.inventoryEmissions;
  const keys = Object.keys(dict);
  if (keys.length === 0) {
    return false;
  }
  return typeof dict[keys[0]] === 'number';
}

export function isDashboardReportedCalculationResult(
  result: DashboardV4ReportedEmissionsCalculationResult | DashboardReportedEmissionsCalculationResult
): result is DashboardReportedEmissionsCalculationResult {
  if (!result) {
    return false;
  }
  if (!result.inventoryEmissions) {
    return false;
  }
  const dict = result.inventoryEmissions;
  const keys = Object.keys(dict);
  if (keys.length === 0) {
    return false;
  }
  return typeof dict[keys[0]] === 'object';
}
